<template>
    <div>
        <!-- loader fontawesome -->
        <div class="flex items-center justify-center h-screen">
            <div class="text-center">
                <i class="fas fa-spinner fa-spin text-4xl text-slate-600"></i>
                <p class="mt-4 text-lg text-gray-700">Vérification du lien de connexion...</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Auth',
        async mounted() {
            let token = this.$route.query.token
            if (!token) {
                this.$router.push({name: 'Login'})
                return
            }

            let accountExists = await this.$request.post('/auth/check-token', {
                token: token
            })
            if (accountExists) {
                if (this.$route.query.session) {
                    sessionStorage.setItem('auth-token', token)
                } else {
                    localStorage.setItem('auth-token', token)
                }

                if (this.$route.query.redirect) {
                    let routes = this.$router.getRoutes()
                    let redirectUrl = routes.find(r => r.name === this.$route.query.redirect)
                    if (!redirectUrl) {
                        this.$toast.error('La page de redirection spécifiée est invalide.')
                        window.location.href = '/app'
                        return
                    }
                    window.location.href = redirectUrl.path
                    return
                }

                window.location.href = '/app'
                return
            } else {
                this.$toast.error('Le lien de connexion est invalide ou a expiré.')
                this.$router.push({name: 'Login'})
                return
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>